const Team = () => import("@/modules/team/pages/Team.vue");
const InviteTeamMember = () =>
  import("@/modules/team/pages/InviteTeamMember.vue");
const EditTeamMember = () => import("@/modules/team/pages/EditTeamMember.vue");
const DeleteTeamMember = () =>
  import("@/modules/team/pages/DeleteTeamMember.vue");
const CancelTeamInvite = () =>
  import("@/modules/team/pages/CancelTeamInvite.vue");

export default [
  {
    path: "/settings/team",
    name: "team",
    component: Team,
    children: [
      {
        path: "/settings/team/invite",
        name: "inviteTeamMember",
        component: InviteTeamMember,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/team/edit/:memberId",
        name: "editMember",
        component: EditTeamMember,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/team/delete/:memberId",
        name: "deleteMember",
        component: DeleteTeamMember,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/settings/team/invite/cancel/:memberId",
        name: "cancelInvitation",
        component: CancelTeamInvite,
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
    },
  },
];
